export default __webpack_public_path__ + "static/B0188-ee1dcae6092510849653a2953b5fe018.png";